<template>
    <transition name="fade">
        <div
            v-if="product"
            class="Results Results--calculator"
            :class="{ 'Results--mobile': isMobile }"
        >

            <h2
                v-routing-animation="{speedModifier: 50}"
                class="Results-header">
                <span>{{ translation.calculate.result.heading }}</span>
            </h2>

            <div
                v-routing-animation="{speedModifier: 50, index: 2}"
                class="Results-selection"
                v-if="!isMobile">
                <hempel-selection :selection="selection"/>
            </div>

            <div
                class="Calculator"
                :class="{ 'Calculator--mobile': isMobile }"
            >
                <div class="Calculator-image">
                    <div class="Calculator-title">
                        <strong>{{ product.name || 'No name' }}</strong>
                        <strong>{{ product.productId || 'No ID' }}</strong>
                    </div>

                    <img
                        :src="product.img || '/images/placeholder.png'"
                        alt="Bucket"
                    >

                    <div
                        class="Calculator-links"
                        :class="{ 'Calculator-links--desktop': !isMobile }"
                    >
                        <!-- NOTE: prikaz po jeziku aplikacije (UI), uz fallbackove -->
                        <p
                            v-if="calcNote"
                            class="Result-actionsNote Calculator-note"
                        >
                            {{ calcNote }}
                        </p>

                        <hempel-link
                            v-routing-animation="{speedModifier: 50, index: 2}"
                            @click="openOverlay('recommendation')"
                            :label="translation.calculate.result.recommendation.title"
                            icon="email"
                            v-if="!isMobile"
                            class="Calculator-link"/>
                        <hempel-link
                            v-routing-animation="{speedModifier: 50, index: 2}"
                            @click="openOverlay('feedback')"
                            :label="translation.calculate.result.feedback.title"
                            icon="questionMark"
                            v-if="!isMobile"
                            class="Calculator-link"/>
                    </div>

                    <span
                        class="Calculator-amount"
                        :style="antifoulingBadgeStyle">
                        {{ antifoulingAmountLabel }}
                    </span>
                </div>

                <div
                    v-if="productFromAPI"
                    class="Calculator-header">
                    <div class="Calculator-titleWrapper">
                        <span class="Calculator-headerCategory">{{ product.position }}</span>
                        <strong class="Calculator-headerName">{{ product.name }}</strong>
                    </div>

                    <div class="Calculator-summary--desktop">
                        <span
                            class="Calculator-amount"
                            :style="antifoulingBadgeStyle">
                            {{ antifoulingAmountLabel }}
                        </span>

                        <div
                            class="Calculator-summaryHeadline"
                            v-if="product.productId === '77450' || product.productId === '77222'">
                            {{ translation.calculate.result.suggestedAmountTwoCoats }}
                        </div>
                        <div
                            class="Calculator-summaryHeadline"
                            v-else>
                            {{ translation.calculate.result.suggestedAmount }}
                        </div>

                        <div
                            v-if="suggestedAmountBig"
                            class="Calculator-summaryItem">
                            <hempel-combination
                                :quantity="suggestedAmountBig"
                                :size="volumeMeasurementUnitBig"
                                icon="antifoulingBucket"/>
                        </div>
                        <div
                            v-if="suggestedAmountSmall && suggestedAmountBig"
                            class="Calculator-summaryItem--faded">+</div>
                        <div
                            v-if="suggestedAmountSmall"
                            class="Calculator-summaryItem">
                            <hempel-combination
                                :quantity="suggestedAmountSmall"
                                :size="volumeMeasurementUnitSmall"
                                icon="antifoulingCan"/>
                        </div>
                    </div>
                </div>

                <div class="Calculator-summary">
                    <div
                        class="Calculator-summaryHeadline"
                        v-if="product.productId === '77450' || product.productId === '77222'">
                        {{ translation.calculate.result.suggestedAmountTwoCoats }}
                    </div>
                    <div
                        class="Calculator-summaryHeadline"
                        v-else>
                        {{ translation.calculate.result.suggestedAmount }}
                    </div>

                    <div class="Calculator-summaryCans">
                        <div
                            v-if="suggestedAmountBig"
                            class="Calculator-summaryItem">
                            <hempel-combination
                                :quantity="suggestedAmountBig"
                                :size="volumeMeasurementUnitBig"
                                icon="antifoulingBucket"/>
                        </div>
                        <div
                            v-if="suggestedAmountSmall && suggestedAmountBig"
                            class="Calculator-summaryItem--faded">+</div>
                        <div
                            v-if="suggestedAmountSmall"
                            class="Calculator-summaryItem">
                            <hempel-combination
                                :quantity="suggestedAmountSmall"
                                :size="volumeMeasurementUnitSmall"
                                icon="antifoulingCan"/>
                        </div>
                    </div>
                </div>

                <div class="Calculator-divider">+</div>

                <div
                    class="Calculator-content"
                    v-routing-animation="{speedModifier: 50, index: 2}">
                    <hempel-primer-silic-one
                        :volume="calculatedVolumePrimer"
                        :small="calculatedVolumePrimerSmall"
                        v-if="product.productId === '77450'"
                    />
                    <hempel-primer-hempaspeed
                        :volume="calculatedVolumePrimer"
                        :small="calculatedVolumePrimerSmall"
                        v-else-if="product.productId === '77222'"
                    />
                    <hempel-primer
                        :volume="calculatedVolumePrimer"
                        :small="calculatedVolumePrimerSmall"
                        v-else
                    />
                </div>

                <div class="Calculator-content">
                    <br>
                    <hempel-button
                        class="Calculator-whereToBuy"
                        @click="openRetailers()"
                        :label="translation.calculate.result.whereToBuy"
                        primary
                        v-if="checkPaintLocation()"
                    />
                    <br>

                    <div class="Calculator-links">
                        <hempel-link
                            v-routing-animation="{speedModifier: 100, index: 4}"
                            @click="openOverlay('recommendation')"
                            :label="translation.calculate.result.recommendation.title"
                            icon="email"
                            v-if="isMobile"
                            class="Calculator-link"/>
                        <hempel-link
                            v-routing-animation="{speedModifier: 100, index: 4}"
                            @click="openOverlay('feedback')"
                            :label="translation.calculate.result.feedback.title"
                            icon="questionMark"
                            v-if="isMobile"
                            class="Calculator-link"/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
/* eslint-disable no-case-declarations */
import HempelButton from '@/components/shared/button/Button'
import HempelLink from '@/components/shared/link/Link'
import HempelSelection from '@/views/result/ResultSelection'
import HempelPrimer from '@/views/result/ResultPrimer'
import HempelPrimerSilicOne from '@/views/result/ResultPrimerSilicOne'
import HempelPrimerHempaspeed from '@/views/result/ResultPrimerHempaspeed'
import HempelCombination from '@/components/shared/combination/Combination'
import { formatVolumeLabel, getVolumeBadge } from '@/services/volumeDisplay'

const countries = {
    'en-GB': 'UK',
    'en-US': 'US',
    'en-CA': 'US',
    'da-DK': 'Denmark',
    'es-ES': 'Spain',
    'fi-FI': 'Finland',
    'de-DE': 'Germany',
    'el-GR': 'Greece',
    'hr-HR': 'Croatia',
    'it-IT': 'Italy',
    'nb-NO': 'Norway',
    'nl-NL': 'Netherlands',
    'sv-SE_e': 'Sweden - East Coast',
    'sv-SE_w': 'Sweden - West Coast',
    'sv-SE_l': 'Sweden - Lakes',
    'sv-SE': 'Sweden',
    'fr-FR': 'France'
}

export default {
    name: 'HempelCalculatorResults',
    data() {
        return {
            gotProduct: false
        }
    },
    watch: {
        product() {
            this.gotProduct = true
        },
        gotProduct() {
            this.updateAnalytics()
        }
    },
    computed: {
        product() {
            return this.getProduct
        },

        selection() {
            return [
                {
                    label: this.translation.calculate.result.selection.country,
                    value: this.translation.find.answers.paintLocation[0].countries.filter(
                        item => item.value === this.$route.query.paintLocation
                    )[0].label,
                    action: () => {
                        this.switchAction(['paintLocation', 'antifouling'])
                    }
                },
                {
                    label: this.translation.calculate.result.selection.antifouling,
                    value: this.product.name || '',
                    action: () => {
                        this.switchAction(['antifouling'])
                    }
                },
                {
                    label: this.translation.calculate.result.selection.type,
                    value: this.translation.find.answers.type.filter(
                        item => item.value === this.$route.query.type
                    )[0].label,
                    action: () => {
                        this.switchAction(['type', 'keelType', 'dimensions'])
                    }
                },
                {
                    label: this.translation.calculate.result.selection.keelType,
                    value: this.$route.query.keelType
                        ? this.translation.calculate.answers.keelType.filter(
                              item => item.value === this.$route.query.keelType
                          )[0].label
                        : null,
                    action: () => {
                        this.switchAction(['keelType', 'dimensions'])
                    }
                },
                {
                    label: this.translation.calculate.result.selection.dimensions,
                    value: this.dimensionFormater(this.$route.query.dimensions),
                    action: () => {
                        this.switchAction(['dimensions'])
                    }
                }
            ].filter(item => item.value)
        },

        dimensionFormater() {
            return function(dimensions) {
                const d = dimensions.split('-')
                if (!d[1] && !d[2] && !d[3]) {
                    return `${d[4]} m2`
                }
                return `${[d[1], d[2], d[3], d[4]].join(' – ')} ${d[0]}`
            }
        },

        calculatedVolumeAntifouling() {
            const volume = this.calculateVolume('antifouling') * 2
            if (this.product.value === '77450') {
                return this.roundUpOneDecimal(volume)
            }
            return this.roundToOneDecimal(volume)
        },

        // Use the same display value on both layouts and in the recommendation.
        // The underlying volume and packaging calculations remain unchanged.
        antifoulingAmountLabel() {
            const amount = this.isUs
                ? this.roundToOneDecimal(this.litersToGallons(this.calculatedVolumeAntifouling))
                : this.calculatedVolumeAntifouling
            return formatVolumeLabel(amount, this.volumeMeasurementUnitLabelBig)
        },

        antifoulingBadgeStyle() {
            const badge = getVolumeBadge(this.antifoulingAmountLabel, 114, 26)
            return {
                width: `${badge.size}px`,
                height: `${badge.size}px`,
                fontSize: `${badge.fontSize}px`
            }
        },

        suggestedAmountBig() {
            const packaging = this.product.value === '77450' ? 2.5 : 2.25 // Silic One 2.5L
            if (
                this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
            ) {
                const totalGal = parseFloat(this.litersToGallons(this.calculatedVolumeAntifouling))
                const bigCans = Math.floor(totalGal / 0.5)
                return bigCans
            }
            return Math.floor(this.calculatedVolumeAntifouling / packaging)
        },

        suggestedAmountSmall() {
            const packaging = this.product.value === '77450' ? 2.5 : 2.25
            if (
                this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
            ) {
                const totalGal = parseFloat(this.litersToGallons(this.calculatedVolumeAntifouling))
                const bigCans = Math.floor(totalGal / 0.5)
                const remaining = totalGal - bigCans * 0.5
                const smallCans = remaining > 0 ? Math.ceil(remaining / 0.25) : 0
                return smallCans > 0 ? smallCans : null
            }
            return Math.ceil(
                (this.calculatedVolumeAntifouling - this.suggestedAmountBig * packaging) / 0.75
            )
        },

        calculatedVolumePrimer() {
            return this.roundUp(this.calculateVolume('primer'))
        },

        calculatedVolumePrimerSmall() {
            return Math.ceil(this.roundUp(this.calculateVolume('primer')) / 0.75)
        },

        isUs() {
            return (
                this.$route.query.paintLocation === 'en-US' ||
                this.$route.query.paintLocation === 'en-CA'
            )
        },

        volumeMeasurementUnitSmall() {
            return this.isUs ? '0.25gal' : '750ml'
        },

        volumeMeasurementUnitBig() {
            const packaging = this.product.value === '77450' ? '2.5L' : '2.25L'
            return this.isUs ? '0.5gal' : packaging
        },

        volumeMeasurementUnitLabelBig() {
            return this.isUs ? 'gal' : 'L'
        },

        /* --------------------------
       JEZIK NOTE-a (UI → market)
       -------------------------- */

        // 1) UI locale (iz aplikacije)
        uiLocale() {
            let l = null
            try {
                if (this.detectedLanguage) {
                    l = this.detectedLanguage
                }
            } catch (e) {}
            if (!l && this.$i18n && this.$i18n.locale) {
                l = this.$i18n.locale
            }
            return l || 'en-GB'
        },

        // 2) UI "country key" (npr. en-GB -> 'UK', de-DE -> 'Germany' ...)
        uiCountry() {
            const key = countries[this.uiLocale]
            return key || 'UK'
        },

        // 3) Market "country key" iz dropdowna (paintLocation)
        noteCountry() {
            const pl = this.$route && this.$route.query ? this.$route.query.paintLocation : null
            const key = pl ? countries[pl] : null
            return key || 'UK'
        },

        // 4) Finalni string za prikaz
        calcNote() {
            const p = this.product || {}
            const notes = p.note
            if (!notes) return ''

            const uiC = this.uiCountry
            const uiL = this.uiLocale
            const marketC = this.noteCountry
            const marketL =
                this.$route && this.$route.query ? this.$route.query.paintLocation : null

            // helper: pokušaj niz ključeva
            function pickNote(src, keys) {
                for (let i = 0; i < keys.length; i++) {
                    const k = keys[i]
                    if (k && src[k]) return src[k]
                }
                return ''
            }

            // Primarno: UI jezik
            let out = pickNote(notes, [uiC, uiL])
            if (out) return out

            // Sekundarno: zemlja iz dropdowna (market)
            out = pickNote(notes, [marketC, marketL])
            if (out) return out

            // Fallback za švedske pod-regije
            if (
                /^Sweden/.test(uiC) ||
                (uiL && /^sv-SE/.test(uiL)) ||
                /^Sweden/.test(marketC) ||
                (marketL && /^sv-SE/.test(marketL))
            ) {
                if (notes.Sweden) return notes.Sweden
            }

            // Zadnji fallback
            return notes.UK || notes['en-GB'] || ''
        }
    },

    methods: {
        getElementText(element) {
            if (!element) return ''

            // textContent alone joins <strong>CASE 2</strong>Application into
            // "CASE 2Application". Preserve boundaries without changing the UI.
            const copy = element.cloneNode(true)
            const separators = copy.querySelectorAll('p, div, strong, br')
            Array.prototype.forEach.call(separators, node => {
                node.parentNode.insertBefore(document.createTextNode(' '), node)
                node.parentNode.insertBefore(document.createTextNode(' '), node.nextSibling)
            })
            return copy.textContent.replace(/\s+/g, ' ').trim()
        },
        getQuantity(element) {
            const value = this.getElementText(element)
            const match = value.match(/-?\d+(?:[.,]\d+)?/)
            return match ? match[0] : '0'
        },
        getPrimerScope(element) {
            let current = element
            let primerRoot = null

            while (current && current !== document) {
                if (
                    current.classList &&
                    current.classList.contains('VueCarousel-slide')
                ) {
                    return current
                }
                if (
                    !primerRoot &&
                    current.classList &&
                    current.classList.contains('ResultPrimer')
                ) {
                    primerRoot = current
                }
                current = current.parentNode
            }

            return primerRoot || element.parentNode
        },
        getPrimersData() {
            const primers = []
            const seen = {}
            // Only collect this results view; a leaving route may still be in
            // the document during its transition. Keep ALL carousel slides.
            if (!this.$el || !this.$el.querySelectorAll) return primers
            const primerTexts = this.$el.querySelectorAll('.ResultPrimer-copy')

            Array.prototype.forEach.call(primerTexts, primerText => {
                const scope = this.getPrimerScope(primerText)
                if (!scope || !scope.querySelector) return

                const titleElement = scope.querySelector('.ResultPrimer-title')
                const amountElement = scope.querySelector('.ResultPrimer-amount')
                if (!titleElement || !amountElement) return

                const isCarouselSlide =
                    scope.classList &&
                    scope.classList.contains('VueCarousel-slide')
                let quantityBigElement = scope.querySelector(
                    '.hempel-combination-big .Combination-quantity'
                )

                // Silic One and Hempaspeed render the quantity directly in the
                // carousel slide on mobile, without the big/small wrappers.
                if (!quantityBigElement && isCarouselSlide) {
                    quantityBigElement = scope.querySelector(
                        '.ResultPrimer-suggestion .Combination-quantity'
                    )
                }

                const quantitySmallElement = scope.querySelector(
                    '.hempel-combination-small .Combination-quantity, ' +
                    '.hempel-combination-small .combination-small-0'
                )

                const primer = {
                    title: this.getElementText(titleElement),
                    text: this.getElementText(primerText),
                    amount: formatVolumeLabel(this.getElementText(amountElement)),
                    quantityBig: this.getQuantity(quantityBigElement),
                    quantitySmall: this.getQuantity(quantitySmallElement)
                }
                const key = [primer.title, primer.text, primer.amount].join('|')

                if (!seen[key]) {
                    seen[key] = true
                    primers.push(primer)
                }
            })

            return primers
        },
        litersToGallons(liter) {
            return (liter / 3.785).toFixed(2)
        },
        milliliterToQuarts(milliliter) {
            return milliliter * (0.00105669).toFixed(2)
        },
        checkPaintLocation() {
            if (this.$route.query.paintLocation == 'el-GR') return false
            return true
        },
        openRetailers() {
            if (this.$route.query.paintLocation == 'da-DK') {
                window.open('https://www.hempelyacht.dk/da-DK/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'en-GB') {
                window.open('https://www.hempelyacht.com/en-GB/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'en-US') {
                window.open('https://www.hempelyacht.com/en-us/where-to-buy', '_blank')
            }
            if (this.$route.query.paintLocation == 'en-CA') {
                window.open(
                    'https://www.hempelyacht.com/en-us/where-to-buy/canada-retailers',
                    '_blank'
                )
            }
            if (this.$route.query.paintLocation == 'es-ES') {
                window.open('https://www.hempelyacht.es/es-ES/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'hr-HR') {
                window.open('https://www.hempelyacht.hr/hr-HR/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'fi-FI') {
                window.open('https://www.hempelyacht.fi/fi-FI/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'de-DE') {
                window.open('https://www.hempelyacht.de/de-DE/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'nb-NO') {
                window.open('https://www.hempelyacht.no/nb-NO/retailers', '_blank')
            }
            if (this.$route.query.paintLocation == 'nl-NL') {
                window.open('https://www.hempelyacht.nl/nl-NL/retailers', '_blank')
            }
            if (
                this.$route.query.paintLocation == 'sv-SE_e' ||
                this.$route.query.paintLocation == 'sv-SE_w' ||
                this.$route.query.paintLocation == 'sv-SE_l'
            ) {
                window.open('https://www.hempelyacht.se/sv-SE/retailers', '_blank')
            }
        },
        updateAnalytics() {
            this.dataLayerAdd(
                { type: 'virtualPageview' },
                `/calculate-volume/end/${this.product.position}/${this.product.name}-${
                    this.product.productId
                }`
            )
        },
        switchAction(ignoreValues) {
            const { query } = this.$route
            ignoreValues = ignoreValues || []
            ignoreValues.forEach(ignoreValue => {
                delete query[ignoreValue]
            })
            this.$router.push({ path: this.$route.path.split('_')[0], query })
        },
        calculateVolume(type) {
            if (!this.getSelectedProduct || !this.getSelectedProduct.coverage) {
                return 0
            }
            const boatType = this.$route.query.type
            const keel = this.$route.query.keelType || null
            const coverage = this.getSelectedProduct.coverage
            const dimensions = this.$route.query.dimensions
            let volume

            if (
                !dimensions.split('-')[1] &&
                !dimensions.split('-')[2] &&
                !dimensions.split('-')[3] &&
                dimensions.split('-')[4]
            ) {
                // m2 input
                if (type === 'antifouling') {
                    volume = dimensions.split('-')[4] / coverage
                } else {
                    volume = dimensions.split('-')[4] / 7.8
                }
            } else {
                // individual dimensions
                const unit = dimensions.split('-')[0]
                const low =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[1] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[1] * 0.3048).toFixed(2))
                const beam =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[2] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[2] * 0.3048).toFixed(2))
                const draft =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[3] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[3] * 0.3048).toFixed(2))

                if (type === 'antifouling') {
                    if (boatType !== 'sailing') {
                        volume = low * (beam + draft) * 0.85 / coverage
                    } else {
                        volume =
                            keel === 'fin'
                                ? low * (beam + draft) * 0.5 / coverage
                                : low * (beam + draft) * 0.75 / coverage
                    }
                } else if (boatType !== 'sailing') {
                    volume = low * (beam + draft) * 0.85 / 7.8
                } else {
                    volume =
                        keel === 'fin'
                            ? low * (beam + draft) * 0.5 / 7.8
                            : low * (beam + draft) * 0.75 / 7.8
                }
            }
            return volume
        },
        roundUp(number) {
            return Math.ceil(number * 2) / 2
        },
        roundUpQuarter(number) {
            return Math.ceil(4 * number) / 4
        },
        roundToOneDecimal(number) {
            return Math.round(number * 10) / 10
        },
        roundUpOneDecimal(number) {
            return Math.ceil(number * 10) / 10
        },
        goToMap() {
            this.$router.push({
                name: 'map',
                params: { country: this.$route.query.paintLocation }
            })
        },
        scrollScreen() {
            setTimeout(() => {
                this.$scrollTo('.Header', this.scrollOptions)
            }, 200)
        },
        openOverlay(type) {
            switch (type) {
                case 'feedback':
                    this.setFeedback(true)
                    break
                case 'recommendation':
                    const product = {
                        id: this.product.productId,
                        title: this.product.name,
                        type: this.capitalizeFirstLetter(this.product.position || ''),
                        image:
                            this.product.img ||
                            '/images/placeholder.png',
                        amount: this.antifoulingAmountLabel,
                        badge: getVolumeBadge(this.antifoulingAmountLabel, 120, 26),
                        suggested: {
                            small: {
                                quantity: this.suggestedAmountSmall || 0,
                                size: this.volumeMeasurementUnitSmall
                            },
                            large: {
                                quantity: this.suggestedAmountBig || 0,
                                size: this.volumeMeasurementUnitBig
                            }
                        },
                        primers: this.getPrimersData().map(primer => ({
                            title: primer.title,
                            text: primer.text,
                            amount: primer.amount,
                            badge: getVolumeBadge(primer.amount, 80, 18),
                            small: {
                                quantity: primer.quantitySmall,
                                size: this.isUs ? '0.25gal' : '750ml'
                            },
                            large: {
                                quantity: primer.quantityBig,
                                size: this.isUs ? '0.5gal' : '2.25L'
                            }
                        }))
                    }
                    this.setRecommendation(product)
                    break
                case 'map':
                    this.setMap(true)
                    break
                default:
                    break
            }
        }
    },

    components: {
        HempelButton,
        HempelLink,
        HempelSelection,
        HempelPrimer,
        HempelPrimerSilicOne,
        HempelPrimerHempaspeed,
        HempelCombination
    },

    beforeMount() {
        this.scrollScreen()
    },

    mounted() {
        this.updateAnalytics()
    }
}
</script>
